module.exports = __webpack_public_path__ + "Flag-368.a219651b321a049232db769d07b8068b.svg";